import { config } from '@/shared/app.config'
import FormService from '@/shared/services/form-service'

const state = {
  languages: [],
  currentLanguage: '',
}

function getBrowserLocale() {
  const language = navigator.language || navigator.userLanguage
  return language.startsWith('es') ? 'es' : 'en'
}

const mutations = {
  recoverLanguages(_) {
    const languages = JSON.parse(localStorage.getItem('languages'))
    if (!languages) {
      this.dispatch('languages/getLanguages')
    } else {
      state.languages = languages
    }
  },
  recoverCurrentLanguage(_) {
    const currentLanguage = JSON.parse(localStorage.getItem('currentLanguage'))
    if (!currentLanguage) {
      // Set browser language as default if not found in localStorage
      state.currentLanguage = getBrowserLocale()
      this.commit('languages/setCurrentLanguage', state.currentLanguage)
    } else {
      state.currentLanguage = currentLanguage
    }
  },
  setCurrentLanguage(_, payload) {
    state.currentLanguage = payload || getBrowserLocale()
    FormService.reloadFormValidationMessages()
    localStorage.setItem(
      'currentLanguage',
      JSON.stringify(state.currentLanguage),
    )
  },
}

const actions = {
  getLanguages({ commit }) {
    localStorage.setItem('languages', JSON.stringify(config.locales))
    commit('recoverLanguages')
  },
  setDefaultLanguage({ commit }) {
    localStorage.removeItem('currentLanguage')
    commit('setCurrentLanguage', getBrowserLocale())
  },
}

const getters = {
  getLanguages: state => state.languages,
  getCurrentLanguage: state => {
    if (state.currentLanguage) return state.currentLanguage
    return getBrowserLocale()
  },
  getLocaleDatePicker: state => {
    if (state.currentLanguage) return config.localesDatePicker[state.currentLanguage]
    return config.localesDatePicker[config.defaultLocale]
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
